import { put, select, takeLatest } from 'redux-saga/effects'
import { getPnMedicationSelector } from '../selectors/pnMedication.selector'
import { setAddMedicationAdministeredData } from '../store/pnMedication.actions'
import { PnMedicationConstants } from '../store/pnMedication.constants'
import { IPnMedicationState } from '../store/pnMedication.types'
import { performWithMutexHOG } from '../../../../services/mutexUtility.service'
import { throwPcrException } from '../../../pcr/store/pcr.actions'
import { cloneDeep } from 'lodash'

export function* setMedicationPNNNV() {
  const pnMedicationState: IPnMedicationState = yield select(getPnMedicationSelector)
  try {
    const { medicationPNNV, pnMedication, addMedicationAdministeredData } = pnMedicationState
    const selectedMedicationIndex = addMedicationAdministeredData?.findIndex(
      (medication) => medication.id === pnMedication?.id
    )
    if (selectedMedicationIndex > -1) {
      const addMedicationAdministeredDataClone = cloneDeep(addMedicationAdministeredData)
      addMedicationAdministeredDataClone[selectedMedicationIndex].medicationPNNV = medicationPNNV
      yield put(setAddMedicationAdministeredData(addMedicationAdministeredDataClone))
    }
  } catch (e) {
    yield put(throwPcrException(`setMedicationPNNNV() error: ${e}`))
  }
}

export function* setMedicationPNNNVSaga() {
  yield takeLatest([PnMedicationConstants.SET_MEDICATION_PNNV], performWithMutexHOG, setMedicationPNNNV)
}
